import { useEffect, useMemo } from 'react'
import { useStore } from '@nanostores/react'

import { AccidentAtlasRegionId } from '../types/region'
import { buildAccidentAtlasView } from '../lib/buildAccidentAtlasView'
import { AccidentAtlasCmsTile } from '../types/tile'
import { AccidentAtlasLoadStatus, AccidentAtlasView } from '../types/view'
import {
  $accidentAtlasError,
  $accidentAtlasRaw,
  $accidentAtlasStatus,
  loadAccidentAtlasData,
} from '@services/stores/accidentAtlas'

type UseAccidentAtlasDataParams = {
  cmsTiles?: AccidentAtlasCmsTile[]
  selection?: AccidentAtlasRegionId
}

type UseAccidentAtlasDataResult = {
  view: AccidentAtlasView | null
  status: AccidentAtlasLoadStatus
  error: string | null
  reload: () => Promise<void>
}

export default function useAccidentAtlasData({
  cmsTiles,
  selection,
}: UseAccidentAtlasDataParams): UseAccidentAtlasDataResult {
  const rawData = useStore($accidentAtlasRaw)
  const status = useStore($accidentAtlasStatus)
  const error = useStore($accidentAtlasError)

  useEffect(() => {
    loadAccidentAtlasData()
  }, [])

  const view = useMemo(
    () =>
      buildAccidentAtlasView({
        cmsTiles,
        rawData,
        selection,
      }),
    [cmsTiles, rawData, selection]
  )

  async function reload(): Promise<void> {
    await loadAccidentAtlasData(true)
  }

  return { view, status, error, reload }
}
